import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import classNames from 'classnames';
import Select from '@jetbrains/ring-ui/components/select/select';
import { AI_PROVIDERS } from '@modules/ai/common/constants';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './default-profile-selector.css';
export function DefaultProfileSelector(props) {
    const { className, availableProviders, defaultProviders, onDefaultProviderSelected, onDefaultProviderDeselected } = props;
    const handleDefaultProviderSelected = useCallback((provider) => {
        if (provider) {
            onDefaultProviderSelected(provider.key);
        }
    }, [onDefaultProviderSelected]);
    const handleDefaultProviderDeselected = useCallback((provider) => {
        if (provider) {
            onDefaultProviderDeselected(provider.key);
        }
    }, [onDefaultProviderDeselected]);
    return (_jsxs("div", { className: classNames(styles.wrapper, className), children: [_jsx("p", { className: styles.message, children: "You removed one of the default providers. Please verify current set or choose a new one." }), _jsx(Select, { multiple: true, selectedLabel: "Default AI providers", data: availableProviders.map(provider => ({
                    ...AI_PROVIDERS[provider],
                    ...assignTestId(provider)
                })), selected: defaultProviders.map(p => AI_PROVIDERS[p]), onSelect: handleDefaultProviderSelected, onDeselect: handleDefaultProviderDeselected, className: styles.selector, ...assignTestId('default-provider-select') })] }));
}
